import { RedactionInput } from "../../../__generated__/gql-types/globalTypes";

export const initialValuesObj: RedactionInput = {
  title: "",
  question: "",
  needs_evidence: false,
  rubrics: [],
};
